module.exports = __webpack_public_path__ + "img/header.fb942748.jpeg";